import select2 from "select2";
import "./_form.scss";

//AUTOSIZE FORM TEXT AREA WHEN TYPING. THANKS TO TEXTAREA-AUTOSIZE.JS
//autosize(document.querySelectorAll("textarea"));

$("select").select2();
